module.exports = __webpack_public_path__ + "img/restaurant.07a13d60.jpg";